module.exports = {
      id: "excluded-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "images/sprites__rbhs--7cf081e3aea2348fa703373fd510183b.svg#excluded-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__rbhs/sprites/excluded.svg
// module id = /tool/node_modules/svg-sprite-loader/lib/loader.js??ref--19-0!/tool/project/client/src/site__rbhs/sprites/excluded.svg
// module chunks = site__rbhs